import { validInputNumber } from "../utils";
import { T, TF } from "react-translator-component";

export const postalCodeValidate = (value: string) => {
  const inputValueCheck = validInputNumber(value)
  if (!inputValueCheck.valid) {
    return { valid: false,  error: inputValueCheck.error }
  } else if (value.length < 7) {
    return { valid: false,  error: TF(T("error_validate_postal_code"), 7)}
  }
  return { valid: true,  error: "" }
}
